// Mascot reactions
(function () {
  if (!window.theme.settings.mascotEnabled) return;
  const target = document.querySelector('[data-mascot-target]');
  if (!target) return;
  const speech = target.querySelector('[data-mascot-speech]');
  const mouth = target.querySelector('[data-mascot-mouth]');
  const eyes = target.querySelector('[data-mascot-eyes]');
  const lines = ["hi i'm marlo!", 'whisk whisk whisk', 'ooh that tickles', 'drink me!', 'おいしい~', 'more foam pls'];

  target.addEventListener('mouseenter', () => {
    speech.textContent = lines[Math.floor(Math.random() * lines.length)];
    speech.classList.add('show');
    // wink: hide right eye, draw arc
    if (eyes) {
      eyes.innerHTML = `<circle cx="96" cy="144" r="6" fill="#1d3014"/>
        <path d="M 138 144 Q 148 140 158 144" stroke="#1d3014" stroke-width="3" fill="none" stroke-linecap="round"/>`;
    }
  });
  target.addEventListener('mouseleave', () => {
    speech.classList.remove('show');
    if (eyes) {
      eyes.innerHTML = `<circle cx="96" cy="144" r="6" fill="#1d3014"/>
        <circle cx="148" cy="144" r="6" fill="#1d3014"/>
        <circle cx="98" cy="142" r="2" fill="#fbf7eb"/>
        <circle cx="150" cy="142" r="2" fill="#fbf7eb"/>`;
    }
  });
  target.addEventListener('click', () => {
    speech.textContent = 'eep!';
    speech.classList.add('show');
    if (mouth) mouth.setAttribute('d', 'M 122 162 a 8 10 0 1 0 0.1 0 Z');
    setTimeout(() => {
      if (mouth) mouth.setAttribute('d', 'M 108 158 Q 122 170 138 158');
    }, 600);
  });
})();
